var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { StartSSOAuthentication, useSSOClient, useSubscribeToBroadcastMessage, } from '@lucidlink/workspacemanagement';
import { useOnAuthCodeReceived, useStartSsoAuthentication } from './hooks';
export const WorkspaceSSOAuthentication = () => {
    _react_refresh_temp_2();
    const { exchangeCode, initializeAuthentication } = useSSOClient();
    const onAuthCodeReceived = useOnAuthCodeReceived(exchangeCode);
    useSubscribeToBroadcastMessage({
        callback: onAuthCodeReceived,
        messageType: 'auth-code-received',
    });
    const startSSOAuthentication = useStartSsoAuthentication(initializeAuthentication);
    return (_jsx(StartSSOAuthentication, { onStartSSOAuthentication: () => void startSSOAuthentication() }));
};
_react_refresh_temp_1 = WorkspaceSSOAuthentication;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceSSOAuthentication");
_react_refresh_temp_2(WorkspaceSSOAuthentication, "c5sisaLMLdw13rZjgfJTb94Og/c=", false, () => [useSSOClient, useOnAuthCodeReceived, useSubscribeToBroadcastMessage, useStartSsoAuthentication]);
